export const MOBILE_APP_AUTH_STATE = {
    ASK_USE_FINGER: 'askUseFinger',
    CREATE_FINGER: 'createFinger',
    CREATE_FINGER_DONE: 'createFingerDone',
    DONE: 'done',
    ENTER_PIN: 'enterPin',
    INIT: 'init',
    PIN1: 'pin1',
    PIN2: 'pin2',
}
